import * as Yup from "yup"
import { Paragraph } from "../Components/Paragraph"
import { DEFAULT_ORGANIZATION, DEFAULT_ORGANIZATION_OPTION } from "../constants/defaultOrganization"
import { EMAIL_REGEX } from "../constants/regex"
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "../constants/textConstants"

export const onboardingFlowSteps = (organizations = [DEFAULT_ORGANIZATION_OPTION]) => [
  {
    id: "welcome",
    title: "You're 10 minutes away from starting a personalized Mentor Circle Plan!",
    renderCustomContent: () => (
      <div className="py-8 text-center">
        <Paragraph>Every student is one of a kind! Their Mentor Circle should be too!</Paragraph>
        <Paragraph>
          Share a bit about yourself and we&apos;ll walk you through the rest! Our process helps
          students form a life-changing Mentor Circle rooted in Christian faith and trusted
          relationships.
        </Paragraph>
      </div>
    ),
    nextButtonText: "Let's go!",
  },
  {
    id: "email",
    title: <span>Before we get started, what&apos;s <em>your</em> email address?</span>,
    fieldType: "email",
    fieldName: "email",
    fieldProps: { placeholder: "Your email address" },
    validation: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address.")
        .matches(EMAIL_REGEX, "Please enter a valid email format.")
        .required("Email is required."),
    }),
  },
  {
    id: "name",
    title: "Welcome!",
    subtitle: <span>What is <em>your</em> first and last name?</span>,
    fields: [
      {
        fieldType: "text",
        fieldName: "first_name",
        label: "First Name",
        required: true,
        fieldProps: { placeholder: "Your first name" },
      },
      {
        fieldType: "text",
        fieldName: "last_name",
        label: "Last Name",
        required: true,
        fieldProps: { placeholder: "Your last name" },
      },
    ],
    validation: Yup.object({
      first_name: Yup.string().required("Please enter your first name"),
      last_name: Yup.string().required("Please enter your last name"),
    }),
  },
  {
    id: "affiliations",
    title: "Are you affiliated with any of the organizations below?",
    fields: [
      {
        fieldType: "select",
        fieldName: "organization_id",
        label: "Select your affiliation",
        fieldProps: { options: organizations },
      },
      {
        fieldType: "checkbox",
        fieldName: "agreed_to_terms",
        required: true,
        containerClassName: "mb-4 flex flex-col items-center",
        fieldProps: {
          label: (
            <span className="whitespace-nowrap">
              I agree to the{" "}
              <a href={TERMS_OF_SERVICE_URL} className="underline text-brand">
                Terms and Conditions
              </a>
            </span>
          ),
        },
      },
      {
        fieldType: "checkbox",
        fieldName: "agreed_to_youth_policy",
        required: true,
        containerClassName: "mb-4 flex flex-col items-center",
        fieldProps: {
          label: (
            <span className="whitespace-nowrap">
              I agree to the{" "}
              <a href={PRIVACY_POLICY_URL} className="underline text-brand">
                Encircled Student Policy
              </a>
            </span>
          ),
        },
      },
      {
        fieldType: "checkbox",
        fieldName: "marketing_opted_in",
        containerClassName: "mb-4 flex flex-col items-center",
        fieldProps: {
          label: (
            <span>
              Help our mission grow by signing up to receive Marketing Communications
            </span>
          ),
        },
      },
    ],
    validation: Yup.object({
      organization_id: Yup.string().notRequired(),
      agreed_to_terms: Yup.boolean().oneOf([true], "You must agree to the terms and conditions"),
      agreed_to_youth_policy: Yup.boolean().oneOf([true], "You must agree to the Encircled Student Policy"),
    }),
  },
]

export const onboardingInitialValues = {
  email: "",
  first_name: "",
  last_name: "",
  organization_id: DEFAULT_ORGANIZATION,
  agreed_to_terms: false,
  agreed_to_youth_policy: false,
  marketing_opted_in: true,
}
